import colors from "./QuiqButton.scss";

const materialOverrides = {
  "@global": {
    ".QuiqButton__button": {
      "&--blue": {
        "&:hover": {
          backgroundColor: colors.blueHover
        },
        backgroundColor: colors.blue,
        color: colors.white
      },
      "&--green": {
        "&:hover": {
          backgroundColor: colors.greenHover
        },
        backgroundColor: colors.green,
        color: colors.white
      },
      "&--red": {
        "&:hover": {
          backgroundColor: colors.redHover
        },
        backgroundColor: colors.red,
        color: colors.white
      },
      "&--white": {
        "&:hover": {
          backgroundColor: colors.whiteHover
        },
        backgroundColor: colors.white,
        color: colors.black
      },
      borderColor: colors.moodysBlue,
      color: colors.moodysBlue,
      letterSpacing: "1.2px",
      width: "100%"
    },
    ".QuiqButton__spinner": {
      color: colors.gray,
      opacity: 0.7
    }
  }
};

export default materialOverrides;



// WEBPACK FOOTER //
// ./src/shared/QuiqButtonMaterialOverrides.js